import { kebabCase } from 'lodash';
import styled from 'styled-components';
import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import { Button } from 'components/atoms/button';

export const CpButton = styled(Button).attrs((props) => ({
  'data-btn-type': props?.type,
}))<{
  cpType: CustomerPortalButtonType;
}>`
  font-size: var(--cp-${(props) => kebabCase(props.cpType)}-button-font-size);
  color: var(--cp-${(props) => kebabCase(props.cpType)}-button-color);
  background: var(--cp-${(props) => kebabCase(props.cpType)}-button-bg);
  font-family: var(
    --cp-${(props) => kebabCase(props.cpType)}-button-font-family
  );
  font-weight: var(
    --cp-${(props) => kebabCase(props.cpType)}-button-font-weight
  );
  border-radius: var(
    --cp-${(props) => kebabCase(props.cpType)}-button-border-radius
  );
  border-width: var(
    --cp-${(props) => kebabCase(props.cpType)}-button-border-width
  ) !important;
  border-color: var(
    --cp-${(props) => kebabCase(props.cpType)}-button-border-color
  ) !important;

  &.ant-btn {
    padding-left: 1.65rem;
    padding-right: var(--spacing-07);
  }

  &.ant-btn:hover {
    border-color: var(--cp-border-color) !important;
  }
  &.ant-btn:active {
    border-color: var(--cp-border-color) !important;
  }
  &[iconplacement='right'] {
    svg {
      margin-right: 0;
      margin-left: var(--spacing-04);
    }
  }
  &[iconplacement='left'] {
    svg {
      margin-left: 0;
      margin-right: var(--spacing-04);
    }
  }
`;

export const CpBlackButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-small);
  padding: var(--cp-spacing-04) var(--cp-spacing-06);
  width: 181px;
  box-shadow: none;
  border: none;

  @media (max-width: 480px) {
    width: 100%;
  }

  background: var(--cp-black);
  color: var(--cp-white);

  :hover {
    background: var(--cp-black-opacity-80-hover);
  }

  :active {
    background: var(--cp-black-opacity-90-hover);
  }

  &[iconplacement='right'] {
    svg {
      margin-right: 0;
      margin-left: var(--spacing-04);
    }
  }
  [iconplacement='left'] {
    svg {
      margin-left: 0;
      margin-right: var(--spacing-04);
    }
  }
`;

export const CpWhiteButton = styled(CpBlackButton)`
  color: var(--cp-black);
  background: var(--cp-white);

  :hover {
    background: var(--cp-white-opacity-80-hover);
  }

  :active {
    background: var(--cp-white-opacity-90-hover);
  }
`;
